import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { 
  checkmark, 
  checkmarkCircle, 
  informationCircle, 
  search, 
  trash, 
  camera, 
  images,
  at,
  card,
  wallet,
  business,
  person,
  idCard,
  close,
  closeCircle,
  refresh,
  refreshCircle,
  logOut
} from 'ionicons/icons';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Registrar los iconos
addIcons({
  'checkmark': checkmark,
  'checkmark-circle': checkmarkCircle,
  'information-circle': informationCircle,
  'search': search,
  'trash': trash,
  'camera': camera,
  'images': images,
  'at': at,
  'card': card,
  'wallet': wallet,
  'business': business,
  'person': person,
  'id-card': idCard,
  'close': close,
  'close-circle': closeCircle,
  'refresh': refresh,
  'refresh-circle': refreshCircle,
  'log-out': logOut
});

// Manejar errores de carga de chunks en producción
window.addEventListener('error', (event) => {
  if (event.message && (event.message.includes('chunk') || event.message.includes('Loading chunk'))) {
    console.error('Error de chunk detectado:', event);
    // Limpiar caché y recargar
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    // Recargar después de un breve delay
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    // Deshabilitar PreloadAllModules en producción para evitar problemas de caché
    environment.production 
      ? provideRouter(routes)
      : provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
  ],
}).catch((error) => {
  console.error('Error al inicializar la aplicación:', error);
  // Si hay un error crítico, mostrar mensaje al usuario
  if (error.message && error.message.includes('chunk')) {
    alert('Error al cargar la aplicación. Por favor, recargue la página.');
    window.location.reload();
  }
});
